import { UnitEntryStrategy } from './unit-entry.strategy';
import { Injectable, signal } from '@angular/core';

export class DefaultUnitEntryStrategy extends UnitEntryStrategy {
  quantityEntryDisabled = signal(false);
  enabled = signal(true);
}
